import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import TakeOffGroupingComponent from '@/components/DynamicComponents/Admin/MasterData/Project/TakeoffGrouping'
import _ from 'lodash'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import { AgGridVue } from 'ag-grid-vue'
import ActionRenderer from '../../GridRenderer/actionRendere'
import CostPriceRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CommentsRenderer from '@/components/DynamicComponents/Renderers/commentsRenderer'
import {
  calculateGridHeight,
  showNotification,
  customComparator,
} from '@/services/calculate'
import CheckboxRender from '@/components/DynamicComponents/Renderers/checkboxRender'
import Pagination from '@/components/DynamicComponents/Pagination'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ContractComponent from '@/components/DynamicComponents/Admin/MasterData/Project/Contract'
import CategoryCodeComponent from '@/components/DynamicComponents/Admin/MasterData/Project/CategoryCode'
import ListRenderer from '@/components/DynamicComponents/Renderers/listRenderer'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import { createRequest, tableName } from '@/services/config'

export default {
  components: {
    importTemplates,
    TakeOffGroupingComponent,
    exportTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
    ContractComponent,
    CategoryCodeComponent,
  },
  props: {
    tabKey: String,
    isAddTakeoff: Boolean,
    type: String,
    columnSettings: Array,
    screenId: Number,
    isArchive: Boolean,
  },
  data: function() {
    const checkLength = (rule, value, callback) => {
      const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
      const regUnitCost = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
      let field = rule.field
      switch (rule.field) {
        case 'unitCost':
          field = 'unit cost'
          break
        case 'costMult':
          field = 'cost mult'
          break
        default:
          field = rule.field
          break
      }
      if (rule.field === 'nrmlLife') {
        if (value && !reg.test(value)) {
          callback(
            new Error('Please enter valid nrml life (for e.g.: 12345678.12)'),
          )
        } else {
          callback()
        }
      } else if (rule.field === 'unitCost') {
        if (value && !regUnitCost.test(value)) {
          callback(
            new Error(
              'Please enter valid unit cost life (for e.g.: 1234567891234.12)',
            ),
          )
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(
            new Error(
              'Please enter valid ' + field + ' (for e.g.: 12345678.12)',
            ),
          )
        } else {
          callback()
        }
      }
    }
    const checTextkLength = (rule, value, callback) => {
      if (rule.field === 'takeoff' || rule.field === 'source') {
        let field = 'Description'
        if (rule.field === 'source') {
          field = 'Source'
        }
        if (String(value).length > 100) {
          callback(
            new Error(field + ' must be less than or equals to 100 characters'),
          )
        } else {
          callback()
        }
      } else {
        let field = 'Original description'
        if (rule.field === 'comments') {
          field = 'Comments'
        }
        if (String(value).length > 255) {
          callback(
            new Error(field + ' must be less than or equals to 255 characters'),
          )
        } else {
          callback()
        }
      }
    }
    return {
      fileInput: null,
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'id',
      defaultSortOrder: true,
      page: 0,
      pageSize: 50,
      takeoffList: [],
      visible: false,
      visibleTakeoff: false,
      modalTitle: '',
      form: {
        id: undefined,
        takeoffGroupings: [],
        takeoff: undefined,
        contractId: undefined,
        mContractId: undefined,
        contractName: undefined,
        categoryId: undefined,
        mCategoryCodeId: undefined,
        categoryCode: undefined,
        mAssetClassId: undefined,
        assetClassId: undefined,
        assetClass: undefined,
        source: undefined,
        unitId: undefined,
        mUnitId: undefined,
        unit: undefined,
        unitCost: undefined,
        costMult: 1.0,
        nrmlLife: undefined,
        originalDescription: undefined,
        comments: undefined,
        isActive: 1,
      },
      rules: {
        takeoff: [
          {
            required: true,
            message: 'Please enter takeoff description',
            trigger: 'blur',
          },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        unit: [
          { required: true, message: 'Please select unit', trigger: 'change' },
        ],
        unitCost: [
          {
            required: true,
            message: 'Please enter unit cost',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        categoryCode: [
          {
            required: true,
            message: 'Please select category code',
            trigger: 'change',
          },
        ],
        contractName: [
          {
            required: true,
            message: 'Please select contract',
            trigger: 'change',
          },
        ],
        source: [
          { required: true, message: 'Please enter source', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        costMult: [
          {
            required: true,
            message: 'Please enter cost mult',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        nrmlLife: [{ validator: checkLength, trigger: 'blur' }],
        originalDescription: [
          { message: 'Please enter original description', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        assetClass: [
          {
            required: true,
            message: 'Please enter asset class',
            trigger: 'blur',
          },
        ],
        comments: [
          { message: 'Please enter comments', trigger: 'blur' },
          { validator: checTextkLength, trigger: 'blur' },
        ],
        takeoffGroupings: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one takeoff grouping',
            trigger: 'change',
          },
        ],
      },
      unitList: [],
      categoryCodeList: [],
      takeoffGroupingList: [],
      selectedRowKeys: [],
      loadRefresh: false,
      // gridOptions: null,
      // columnDefs: null,
      defaultColDef: null,
      frameworkComponents: null,
      tableParams: null,
      width: 'auto',
      height: '400px',
      currency: null,
      uploadedFile: null,
      importClicked: false,
      importColDef: [
        {
          checkboxSelection: this.checkboxSelection,
          headerCheckboxSelection: this.headerCheckboxSelection,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Takeoff',
          field: 'Takeoff',
          tooltipField: 'Takeoff',
          width: 200,
        },
      ],
      loadImport: false,
      filters: {},
      contractList: [],
      isAddContract: false,
      isAddCategory: false,
      takeoffGroupings: [],
      updateRequest: null,
      requestKeys: [
        'takeoff',
        'unitCost',
        'source',
        'costMult',
        'nrmlLife',
        'originalDescription',
        'comments',
        'categoryId',
        'mCategoryCodeId',
        'isActive',
        'contractId',
        'mContractId',
        'unitId',
        'mUnitId',
        'assetClass',
      ],
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 60,
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellRendererParams: {
            filter: 'dynamic',
            searchType: 'number',
            name: 'id',
          },
          headerTooltip: 'ID',
          sort: 'asc',
          floatingFilter: false,
          menuTabs: [],
        },
        {
          headerName: 'Takeoff Grouping',
          field: 'takeoffGroupings',
          width: 300,
          headerTooltip: 'Takeoff Grouping',
          filter: 'customFilter',
          comparator: customComparator,
          cellRendererParams: { name: 'takeoffGrouping', filter: 'dynamic' },
          cellRenderer: 'takeoffGroupingCellRenderer',
          sortable: false,
          floatingFilter: false,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          width: 100,
          headerTooltip: 'Takeoff Description',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Contract',
          field: 'contract',
          width: 75,
          headerTooltip: 'Contract',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          width: 80,
          headerTooltip: 'Category Code',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Asset Class',
          field: 'assetClass',
          width: 80,
          headerTooltip: 'Asset Class',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Source',
          field: 'source',
          width: 80,
          headerTooltip: 'Source',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Unit',
          field: 'unit',
          width: 50,
          headerTooltip: 'Unit',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          width: 80,
          cellRenderer: 'costPriceCellRenderer',
          headerTooltip: 'Unit Cost',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Cost MULT',
          field: 'costMult',
          width: 75,
          headerTooltip: 'Cost MULT',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'NRML Life',
          field: 'nrmlLife',
          width: 75,
          headerTooltip: 'NRML Life',
          cellRenderer: 'toolTipRenderer',
          suppressSizeToFit: true,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic', searchType: 'number' },
        },
        {
          headerName: 'Original Description',
          field: 'originalDescription',
          width: 80,
          headerTooltip: 'Original Description',
          cellRenderer: 'toolTipRenderer',
          comparator: customComparator,
          filter: 'customFilter',
          cellRendererParams: { filter: 'dynamic' },
        },
        {
          headerName: 'Comments',
          field: 'comments',
          width: 75,
          sortable: false,
          floatingFilter: false,
          cellRenderer: 'commentsCellRenderer',
          headerTooltip: 'Comments',
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: { title: 'Comments' },
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          cellRenderer: 'actionCellRenderer',
          width: 75,
          suppressSizeToFit: true,
          cellStyle: { textAlign: 'center' },
          cellRendererParams: {
            type: 'Takeoff',
            edit: true,
            delete: true,
          },
          pinned: 'right',
          menuTabs: [],
        },
      ],
    }
  },
  beforeMount() {
    if (this.isAddTakeoff) {
      this.addNew()
    }
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
    if (!this.isArchive) {
      this.getCategoryCodes()
      this.getContract()
      this.getTakeoffGroupings()
      this.getUnits()
    }
  },
  mounted() {
    this.$root.$on('deleteTakeoff', this.deleteTakeoff)
    this.$root.$on('editTakeoff', this.getTakeoffById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '9') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.takeoffList = []
        this.loading = true
        this.defaultSortedBy = 'id'
        this.defaultSortOrder = true
        // this.gridOptions.columnApi.applyColumnState({
        //   state: [
        //     {
        //       colId: 'id',
        //       sort: 'asc',
        //     },
        //   ],
        //   defaultState: { sort: null },
        // })
        this.getTakeoffs(this.tableParams)
        if (!this.isArchive) {
          this.getTakeoffGroupings()
          this.getUnits()
          this.getCategoryCodes()
          this.getContract()
        }
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('deleteTakeoff')
    this.$root.$off('editTakeoff')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        costPriceCellRenderer: CostPriceRenderer,
        commentsCellRenderer: CommentsRenderer,
        checkboxCellRender: CheckboxRender,
        customFilter: CustomFilter,
        takeoffGroupingCellRenderer: ListRenderer,
        toolTipRenderer: ToolTipRenderer,
      }
    },

    // Refresh Takeoff
    refreshTakeoffs() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.takeoffList = []
      this.page = 0
      this.defaultSortedBy = 'id'
      this.defaultSortOrder = true
      this.selectedRowKeys = []
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'id',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getTakeoffs(this.tableParams)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      this.visibleTakeoff = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.form.costMult = 1.0
      if (this.isAddTakeoff) {
        this.$emit('addTakeoff', 'cancel')
      }
    },

    // Add New Takeoff
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Takeoff'
      this.form.id = undefined
      this.form.contractId = undefined
      this.form.categoryId = undefined
      this.form.mContractId = undefined
      this.form.mCategoryCodeId = undefined
      this.form.mUnitId = undefined
      this.form.unitId = undefined
      this.form.isActive = 1
      this.takeoffGroupings = []
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.form.costMult = 1.0
    },

    // Save Takeoff
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateTakeoff()
          } else {
            this.addTakeoff()
          }
        }
      })
    },

    // Get Takeoffs
    getTakeoffs(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        id: _.get(this.filters, 'id', undefined),
        takeoffGrouping: _.get(this.filters, 'takeoffGroupings', undefined),
        takeoff: _.get(this.filters, 'takeoff', undefined),
        contract: _.get(this.filters, 'contract', undefined),
        categoryCode: _.get(this.filters, 'categoryCode', undefined),
        assetClass: _.get(this.filters, 'assetClass', undefined),
        source: _.get(this.filters, 'source', undefined),
        unit: _.get(this.filters, 'unit', undefined),
        unitCost: _.get(this.filters, 'unitCost', undefined),
        costMult: _.get(this.filters, 'costMult', undefined),
        nrmlLife: _.get(this.filters, 'nrmlLife', undefined),
        originalDescription: _.get(
          this.filters,
          'originalDescription',
          undefined,
        ),
      }
      instance
        .post(projectAPIs.master.takeoff.list(this.$route.params.id), req)
        .then(response => {
          this.takeoffList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'takeoffTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSetting()
          } else {
            this.getColumnSettings(params)
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Takeoff By Id
    getTakeoffById(id) {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      instance
        .get(projectAPIs.master.takeoff.details(this.$route.params.id, id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.source = _.get(response.data, 'result.source', null)
          this.form.unit = _.get(response.data, 'result.unit', null)
          this.form.takeoffGroupings = []
          this.takeoffGroupings = []
          this.form.costMult = _.get(response.data, 'result.costMult', null)
          this.form.comments = _.get(response.data, 'result.comments', null)
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.nrmlLife = _.get(response.data, 'result.nrmlLife', null)
          this.form.assetClass = _.get(
            response.data,
            'result.assetClass',
            null,
          )
          this.form.mCategoryCodeId = _.get(
            response.data,
            'result.mCategoryCodeId',
            null,
          )
          this.form.mContractId = _.get(
            response.data,
            'result.mContractId',
            null,
          )
          this.form.takeoff = _.get(response.data, 'result.takeoff', null)
          this.form.originalDescription = _.get(
            response.data,
            'result.originalDescription',
            null,
          )
          this.form.contractName = this.contractList.find(
            element => element.id === this.form.mContractId,
          ).value
          this.form.categoryCode = this.categoryCodeList.find(
            element => element.id === this.form.mCategoryCodeId,
          ).value
          const takeoffGroupings = _.get(
            response.data,
            'result.takeoffGroupings',
            [],
          )
          this.form.mUnitId = _.get(response.data, 'result.mUnitId', null)
          takeoffGroupings.map(element => {
            this.form.takeoffGroupings.push(element.takeoffGrouping)
            this.takeoffGroupings.push({
              id: element.id,
              name: element.takeoffGrouping,
              takeoffGroupingId: element.takeoffGroupingId,
            })
          })
          this.form.unitCost = _.get(response.data, 'result.unitCost', null)

          if (this.form.unit) {
            const unit = this.unitList.find(i => i.option === this.form.unit)
            if (!unit) {
              this.unitList.push({
                option: this.form.unit,
                value: '',
              })
            }
          }
          this.updateRequest = _.get(response.data, 'result', null)
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .delete(projectAPIs.master.takeoff.delete(this.$route.params.id), {
          data: ids,
        })
        .then(response => {
          showNotification(
            'success',
            'Delete Takeoff',
            'Takeoff deleted successfully!',
          )
          this.refreshTakeoffs()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Show Takeoff Groupings
    showTakeoffGrouping() {
      this.visibleTakeoff = true
    },

    // Refresh Takeoff Groupings
    refreshTakeoffGroupings() {
      this.getTakeoffGroupings()
    },

    // Delete All Takeoff
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected takeoffs ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              takeoffs
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Delete Takeoff
    deleteTakeoff(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.takeoff}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this takeoff
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() {},
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.takeoffList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'id'
        this.defaultSortOrder = true
      }
      this.tableState = this.gridOptions.columnApi.getColumnState()
      this.getTakeoffs(this.tableParams, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshTakeoffs()
      }
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    updateTable() {
      this.importClicked = false
      this.refreshTakeoffs()
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'takeoffTable',
        this.count > this.pageSize,
      )
      this.gridOptions.api.sizeColumnsToFit()
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.takeoffList = []
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.getTakeoffs(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.takeoffList = []
      this.loading = true
      this.page = 0
      this.getTakeoffs(this.gridOptions)
    },

    // Dropdown add
    addContract(data, id, flag) {
      this.isAddContract = flag
      if (id) {
        this.contractList.push({
          contract: data.contract,
          contractName: data.contractName,
          id: id,
          isActive: data.isActive,
          isLinked: false,
          option: `${data.contract} - ${data.contractName}`,
          value: `${data.contract} - ${data.contractName}`,
        })
        this.contractList = _.orderBy(this.contractList, ['contract'], ['asc'])
        this.form.contractName = `${data.contract} - ${data.contractName}`
        this.form.mContractId = id
      }
    },

    addCategory(data, id, contracts, flag) {
      this.isAddCategory = flag
      if (id) {
        this.contractList = []
        contracts.forEach(element => {
          this.contractList.push(element)
        })
        this.categoryCodeList.push({
          id: id,
          assetClass: data.assetClass,
          masterAssetClassId: data.mAssetClassId,
          categoryCode: data.categoryCode,
          contract: data.contract.split(' - ')[0],
          contractName: data.contract.split(' - ')[1],
          option: `${data.categoryCode} - ${data.description}`,
          value: `${data.categoryCode} - ${data.description}`,
          description: data.description,
          masterContractDetailsId: data.mContractDetailsId,
        })
        this.categoryCodeList = _.orderBy(
          this.categoryCodeList,
          ['id'],
          ['asc'],
        )
        this.form.mContractId = data.mContractDetailsId
        this.form.assetClass = data.assetClass
        this.form.mCategoryCodeId = id
        this.form.contractName = data.contract
        this.form.categoryCode = `${data.categoryCode} - ${data.description}`
      }
    },

    // Dropdowns
    getUnits() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'unit'))
        .then(response => {
          this.unitList = []
          this.unitList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getCategoryCodes() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'category-code'))
        .then(response => {
          this.categoryCodeList = []
          this.categoryCodeList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getContract() {
      instance
        .get(projectAPIs.dropdown.list(this.$route.params.id, 'contract'))
        .then(response => {
          this.contractList = []
          this.contractList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    getTakeoffGroupings() {
      instance
        .get(
          projectAPIs.dropdown.list(this.$route.params.id, 'takeoff-grouping'),
        )
        .then(response => {
          this.takeoffGroupingList = []
          this.takeoffGroupingList = _.get(response.data, 'result', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    // Dropdown change
    onUnitChange(value) {
      const unit = this.unitList.find(i => i.option === value)
      if (unit) {
        this.form.mUnitId = unit.id ? unit.id : undefined
        this.form.unitId = unit.id ? undefined : unit.masterId
      }
    },

    onChangeGroupings(value) {
      this.takeoffGroupings = []
      value.forEach(element => {
        const group = this.takeoffGroupingList.find(i => i.option === element)
        if (group) {
          this.takeoffGroupings.push({
            id: group['id'],
            name: group.option,
            takeoffGroupingId: group['masterId'],
          })
        }
      })
    },

    onContractChange(value) {
      if (value === 'addContract') {
        this.form.contract = undefined
        this.form.contractName = undefined
        this.isAddContract = true
      } else {
        const contract = this.contractList.find(i => i.value === value)
        this.form.mContractId = contract.id ? contract.id : undefined
        this.form.contractId = contract.id ? undefined : contract.masterId
      }
    },

    onCategoryCodeChange(value) {
      if (value === 'addCategory') {
        this.form.category_Code = undefined
        this.form.categoryCode = undefined
        this.isAddCategory = true
      } else {
        const categoryCode = this.categoryCodeList.find(i => i.value === value)
        if (value) {
          this.form.mCategoryCodeId = categoryCode.id
            ? categoryCode.id
            : undefined
          this.form.categoryId = categoryCode.id
            ? undefined
            : categoryCode.masterId
          this.form.assetClass = categoryCode.assetClass
          this.form.mAssetClassId = categoryCode.assetClassId
            ? categoryCode.assetClassId
            : undefined
          this.form.assetClassId = categoryCode.assetClassId
            ? undefined
            : categoryCode.masterAssetClassId
          this.form.mContractId = categoryCode.contractDetailsId
            ? categoryCode.contractDetailsId
            : undefined
          this.form.contractId = categoryCode.contractDetailsId
            ? undefined
            : categoryCode.masterContractDetailsId
          this.form.contractName = `${categoryCode.contract} - ${categoryCode.contractName}`
        }
      }
    },

    // Add takeoff
    addTakeoff() {
      this.spinner = true
      const grouping = []
      this.takeoffGroupings.map(element => {
        grouping.push({
          id: element.id,
          takeoffGrouping: element.name,
          takeoffGroupingId: element.takeoffGroupingId,
        })
        return element
      })
      const req = {
        takeoff: this.form.takeoff,
        unitCost: this.form.unitCost,
        source: this.form.source,
        costMult: this.form.costMult,
        nrmlLife: this.form.nrmlLife ? this.form.nrmlLife : undefined,
        originalDescription: this.form.originalDescription,
        comments: this.form.comments,
        takeoffGroupings: grouping,
        mCategoryCodeId: this.form.mCategoryCodeId,
        categoryId: this.form.categoryId,
        CategoryCode: Number(this.form.categoryCode.split(' - ')[0]),
        mContractId: this.form.mContractId,
        contractId: this.form.contractId,
        contract: Number(this.form.contractName.split(' - ')[0]),
        mUnitId: this.form.mUnitId,
        unitId: this.form.unitId,
        assetClass: this.form.assetClass,
      }
      instance
        .post(projectAPIs.master.takeoff.add(this.$route.params.id), req)
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification(
              'warning',
              'Create Takeoff',
              response.data.message,
            )
          } else {
            this.visible = false
            showNotification(
              'success',
              'Create Takeoff',
              'Takeoff created successfully!',
            )
            if (this.isAddTakeoff) {
              this.$emit('addTakeoff', 'save')
            } else {
              this.loading = true
              this.getTakeoffs(this.tableParams)
              this.$refs.ruleForm.resetFields()
            }
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Update takeoff
    updateTakeoff() {
      const req = createRequest(
        this.requestKeys,
        this.updateRequest,
        this.form,
      )

      const grouping = []
      let isGroupingValid = false
      this.takeoffGroupings.map(element => {
        const groupIndex = this.updateRequest.takeoffGroupings.findIndex(
          i => i.id === element.id,
        )
        if (groupIndex < 0) {
          isGroupingValid = true
        }
        grouping.push({
          id: element.id,
          takeoffGrouping: element.name,
          takeoffGroupingId: element.takeoffGroupingId,
        })
        return element
      })

      if (isGroupingValid) {
        req.isValid = true
        Object.assign(req.request, {
          takeoffGroupings: grouping,
        })
      }

      Object.keys(req.request).forEach(element => {
        if (element === 'nrmlLife') {
          if (!req.request.nrmlLife) {
            req.request.nrmlLife = null
          }
        }
      })

      if (!req.isValid) {
        showNotification(
          'info',
          'Update Takeoff',
          'No changes found to update!',
        )
        return
      }
      this.spinner = true
      instance
        .patch(
          projectAPIs.master.takeoff.details(
            this.$route.params.id,
            this.form.id,
          ),
          req.request,
        )
        .then(response => {
          this.spinner = false
          if (response.data.message) {
            showNotification(
              'warning',
              'Update Takeoff',
              response.data.message,
            )
          } else {
            this.visible = false
            showNotification(
              'success',
              'Update Takeoff',
              'Takeoff updated successfully!',
            )
            const newData = [...this.takeoffList]
            const index = newData.findIndex(i => i.id === this.form.id)
            newData[index]['id'] = this.form.id
            newData[index]['assetClass'] = this.form.assetClass
            if (this.form.categoryCode) {
              newData[index]['categoryCode'] = this.form.categoryCode.split(
                ' - ',
              )[0]
            }
            newData[index]['mCategoryCodeId'] = this.form.mCategoryCodeId
            newData[index]['comments'] = this.form.comments
            if (this.form.contractName) {
              newData[index]['contract'] = this.form.contractName.split(
                ' - ',
              )[0]
            }
            newData[index]['mContractId'] = this.form.mContractId
            newData[index]['costMult'] = this.form.costMult
            newData[index]['takeoff'] = this.form.takeoff
            newData[index]['isActive'] = this.form.isActive
            newData[index]['nrmlLife'] = this.form.nrmlLife
            newData[index][
              'originalDescription'
            ] = this.form.originalDescription
            newData[index]['source'] = this.form.source
            newData[index]['unit'] = this.form.unit
            newData[index]['mUnitId'] = this.form.mUnitId
            newData[index]['unitCost'] = this.form.unitCost
            newData[index]['takeoffGroupings'] = []
            grouping.forEach(element => {
              newData[index]['takeoffGroupings'].push({
                takeoff_Id: this.form.id,
                takeoff_Grouping_Id: element.id,
                name: element.takeoffGrouping,
              })
            })
            this.takeoffList = newData
            this.$refs.ruleForm.resetFields()
          }
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i =>
          i.screenId === this.screenId &&
          i.tableName === tableName.project.master.takeoff,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
      params.columnApi.applyColumnState({
        state: [
          {
            colId: 'checkbox',
            hide: this.isArchive,
          },
          {
            colId: 'action',
            hide: this.isArchive,
          },
        ],
      })
      if (this.isArchive) {
        if (params) {
          this.tableParams = null
          this.tableParams = params
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: this.screenId,
        tableName: tableName.project.master.takeoff,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },
  },
}
